module.exports = "<app-card-wrapper>\n  <span class=\"title\" translate>account.section.createConsignment.form.package.title</span>\n</app-card-wrapper>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/consignment/search/components/products-form/products-form.component.html
// module id = ./src/app/modules/consignment/search/components/products-form/products-form.component.html
// module chunks = main